import { STAMP_GOAL } from '../constants/lpConfig';

/**
 * スタンプ数が達成しきい値（250）に到達しているか判定
 * 
 * @param {number} stampCount - スタンプ数
 * @returns {boolean} 達成しているかどうか
 */
export const isGoalAchieved = (stampCount) => {
  return stampCount >= STAMP_GOAL;
};

/**
 * スタンプ数をフォーマットして返す
 * 
 * @param {number} stampCount - スタンプ数
 * @returns {string} フォーマット済みスタンプ数（例: "264"）
 */
export const formatStampCount = (stampCount) => {
  return stampCount.toLocaleString();
};

/**
 * スタンプ数に応じたスタンプ積み上げ画像のパスを返す
 *
 * ■ 上野（デフォルト）: 10スタンプ = 1枚として計算
 * | 枚数（stampCount ÷ 10） | 表示イラスト |
 * |------------------------|------------|
 * | 0枚（0スタンプ）         | null（非表示）|
 * | 1〜4枚（1〜49スタンプ）  | stamp-1.png |
 * | 5〜9枚（50〜99スタンプ） | stamp-5.png |
 * | 10〜19枚（100〜199スタンプ）| stamp-10.png|
 * | 20〜24枚（200〜249スタンプ）| stamp-20.png|
 * | 25枚以上（250スタンプ〜）  | stamp-25.png|
 *
 * ■ 桂浜: スタンプ数をそのまま枚数として判定
 * | stampCount | 表示イラスト  |
 * |------------|-------------|
 * | 0          | null（非表示）|
 * | 1〜4       | stamp-1.png |
 * | 5〜9       | stamp-5.png |
 * | 10〜19     | stamp-10.png|
 * | 20〜24     | stamp-20.png|
 * | 25以上     | stamp-25.png|
 *
 * @param {number} stampCount - スタンプ数
 * @param {string} [campaignId] - キャンペーンID
 * @returns {string|null} 画像パス、または null（0スタンプ時）
 */
export const getStampStackImagePath = (stampCount, campaignId) => {
  if (!stampCount || stampCount <= 0) return null;

  const count = campaignId === 'katsurahama'
    ? stampCount
    : Math.floor(stampCount / 10);

  if (count >= 25) return '/images/common/stamp-stack/stamp-25.png';
  if (count >= 20) return '/images/common/stamp-stack/stamp-20.png';
  if (count >= 10) return '/images/common/stamp-stack/stamp-10.png';
  if (count >= 5)  return '/images/common/stamp-stack/stamp-5.png';
  return '/images/common/stamp-stack/stamp-1.png';
};

/**
 * マップ用: スタンプ数に応じたスタンプ積み上げ画像パスを返す
 *
 * | stampCount    | 表示イラスト  |
 * |---------------|-------------|
 * | 0             | null（非表示）|
 * | 1〜49         | stamp-1.png |
 * | 50〜99        | stamp-5.png |
 * | 100〜199      | stamp-10.png|
 * | 200〜249      | stamp-20.png|
 * | 250以上       | stamp-25.png|
 *
 * @param {number} stampCount
 * @returns {string|null}
 */
export const getMapStampStackImagePath = (stampCount) => {
  if (!stampCount || stampCount <= 0) return null;
  if (stampCount >= 250) return '/images/common/stamp-stack/stamp-25.png';
  if (stampCount >= 200) return '/images/common/stamp-stack/stamp-20.png';
  if (stampCount >= 100) return '/images/common/stamp-stack/stamp-10.png';
  if (stampCount >= 50)  return '/images/common/stamp-stack/stamp-5.png';
  return '/images/common/stamp-stack/stamp-1.png';
};
